import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  Output,
  EventEmitter,
} from '@angular/core';

import { Client, Module } from '@shared/models';
import { environment } from '@env/environment';
import { ModuleHasClientAccessPipe } from '@shared/pipes';
import { AccountType } from '@shared/enums';

@Component({
  selector: 'app-module-picker',
  templateUrl: './module-picker.component.html',
  styleUrls: ['./module-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModulePickerComponent implements OnChanges {
  @Input({ required: true }) accountType: AccountType;
  @Input({ required: true }) modules: Module[];
  @Input({ required: true }) selectedClient: Client;
  @Input({ required: true }) isAppOnline: boolean;

  @Output() selected = new EventEmitter<Module>();

  modulesWithAccess: Module[] = [];
  modulesWithoutAccess: Module[] = [];

  coreModule: typeof environment.coreModule = environment.coreModule;

  constructor(private moduleHasClientAccessPipe: ModuleHasClientAccessPipe) {}

  onModuleSelected(module: Module): void {
    this.selected.emit(module);
  }

  trackModule(_index: number, module: Module): string {
    return module?.id;
  }

  ngOnChanges(): void {
    this.populateModulesArrays();
  }

  private populateModulesArrays(): void {
    this.modulesWithAccess = [];
    this.modulesWithoutAccess = [];

    this.modules?.forEach((x) => {
      if (
        this.moduleHasClientAccessPipe.transform(
          x,
          this.accountType,
          this.selectedClient?.modules
        )
      ) {
        this.modulesWithAccess.push(x);
      } else {
        this.modulesWithoutAccess.push(x);
      }
    });
  }
}
